/**
 * System-managed enums for the Rebates module
 *
 * These enum definitions are created automatically when the rebates module is enabled.
 * The enums themselves are immutable (name/description cannot be changed),
 * but the OPTIONS within each enum are fully user-configurable via CRUD operations.
 */

export const REBATES_SYSTEM_ENUMS = {
  AGREEMENT_TAGS: {
    name: "Rebate Agreement Tags",
    description: "Tags for categorizing and filtering rebate agreements",
    options: {
      DUPLICATE: {
        name: "Duplicate",
        description: "Indicates this agreement was created via duplication",
      },
    },
  },
  RULE_TAGS: {
    name: "Rebate Rule Tags",
    description: "Tags for categorizing and filtering rebate rules",
  },
  SUPPLIER_TAGS: {
    name: "Supplier Tags",
    description: "Tags for categorizing and filtering suppliers",
  },
  BANNER: {
    name: "Banner",
    description: "division banners",
    options: {
      US_EAST: {
        name: "US East",
        description: "US East region banner",
      },
      US_MIDWEST: {
        name: "US Midwest",
        description: "US Midwest region banner",
      },
      US_WEST_COAST: {
        name: "US West Coast",
        description: "US West Coast region banner",
      },
      US_SOUTH: {
        name: "US South",
        description: "US South region banner",
      },
    },
  },
  PRODUCT_FAMILY_TAGS: {
    name: "Product Family Tags",
    description:
      "Tags for mapping product groups to profitability data product family descriptions",
  },
} as const;

export type RebatesSystemEnumKey = keyof typeof REBATES_SYSTEM_ENUMS;
